"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCirrusStoreLocationModel = void 0;
const useCirrusStore_1 = require("./useCirrusStore");
function useCirrusStoreLocationModel(locationId, src, options = {}) {
    const manifestUrl = `yanzi://location/${locationId}/model/${src}`;
    return useCirrusStore_1.useCirrusStore(manifestUrl, null, options);
}
exports.useCirrusStoreLocationModel = useCirrusStoreLocationModel;
//# sourceMappingURL=useCirrusStoreLocationModel.js.map